<template>
  <div class="about">
    <h1>This is an common functions component.</h1>
  </div>
</template>
  
  <script>
import companyConfig from "@/company_config.json";
import Swal from "sweetalert2";

export default {
  name: "CommonFunctions",
  props: [],
  mounted() {},
  data() {
    return {};
  },
  methods: {
    LogoutUser() {
      console.log("LogoutUser called");
      localStorage.clear();
      this.$session.destroy();
      this.$router.push("/login");
    },
    toast(title, message) {
      var append = false;
      var toaster = "b-toaster-top-right";
      var variant = "danger";
      var icon = "error";
      switch (title) {
        case "success":
          icon = "success";
          variant = "success";
          break;
        case "error":
          variant = "danger";
          icon = "error";
          break;
        case "warning":
          variant = "warning";
          icon = "warning";
          break;
        default:
          variant = "info";
          icon = "info";
          break;
      }
      console.log("icon=" + icon);

      this.$bvToast.toast(`${message}`, {
        title: `${title}`,
        toaster: toaster,
        appendToast: append,
        variant: variant,
        solid: true,
      });

      /*
              const Toast = Swal.mixin({
                  toast: true,
                  position: "top-end",
                  showConfirmButton: false,
                  timer: 3000,
                  timerProgressBar: true,
                  didOpen: (toast) => {
                  toast.addEventListener("mouseenter", Swal.stopTimer);
                  toast.addEventListener("mouseleave", Swal.resumeTimer);
                  },
              });
              Toast.fire({
                  icon: icon,
                  title: message,
              });
              */
    },
    sweetAlert(title, message, timer) {
      console.log("sweetAlert called");
      var icon = "";
      switch (title) {
        case "success":
          icon = "success";
          break;
        case "error":
          icon = "error";
          break;
        default:
          icon = "info";
          break;
      }
      console.log("icon=" + icon);
      var options = {
        title: "",
        text: message,
        icon: icon,
      };
      if (timer) {
        options.timer = 1500;
        options.timerProgressBar = true;
        options.showConfirmButton = false;
      } else {
        options.showConfirmButton = true;
      }
      Swal.fire(options);
    },
    getSelectBoxOptions(source, destination, condition, url) {
      console.log("getSelectBoxOptions function is called");

      console.log(
        "source=" +
          source +
          ", destination=" +
          destination +
          ", condition=" +
          JSON.stringify(condition) +
          ", url=" +
          url
      );

      var server_url = companyConfig.apiURL;
      console.log("server_url=" + server_url);

      url = server_url + url;
      console.log("url=" + url);

      var token = this.$session.get("token");
      token = token == (null || undefined) ? 0 : token;

      console.log("token=" + token);

      const thisIns = this;
      var output = "";
      var flag = 0;
      var records = [];
      var totalRecords = 0;

      var sourceValue = thisIns[source];
      console.log("sourceValue=" + sourceValue);

      var upload = {
        source: sourceValue,
        additional: condition,
      };
      console.log("upload=" + JSON.stringify(upload));

      this.$http({
        url: url,
        method: "POST",
        data: upload,
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
      })
        .then(function (response) {
          console.log("response=" + JSON.stringify(response));
          output = response.data.output;
          flag = response.data.flag;
          totalRecords = records.length;
          console.log(
            "output=" +
              output +
              ", flag=" +
              flag +
              ", totalRecords=" +
              totalRecords
          );
          if (flag == 1) {
            records = response.data.records;
            thisIns[destination] = records;
          }
        })
        .catch(function (error) {
          console.log("error=" + error);
        });
    },
    getPageDetails(destination, defaultValue, url, condition) {
      console.log("getPageDetails function is called");

      console.log(
        "destination=" +
          destination +
          ", url=" +
          url +
          ", condition=" +
          JSON.stringify(condition)
      );

      var server_url = companyConfig.apiURL;
      console.log("server_url=" + server_url);

      url = server_url + url;
      console.log("url=" + url);

      var token = this.$session.get("token");
      console.log("token=" + token);

      token = token == (null || undefined) ? 0 : token;

      const thisIns = this;
      var output = "";
      var flag = 0;
      var records = defaultValue;
      var totalRecords = 0;

      this.$http({
        url: url,
        method: "POST",
        data: condition,
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
      })
        .then(function (response) {
          console.log("response=" + JSON.stringify(response));
          output = response.data.output;
          flag = response.data.flag;
          totalRecords = records.length;
          console.log(
            "output=" +
              output +
              ", flag=" +
              flag +
              ", totalRecords=" +
              totalRecords
          );
          if (flag == 1) {
            records = response.data.records;
            thisIns[destination] = records;
          } else {
            thisIns[destination] = records;
          }
        })
        .catch(function (error) {
          console.log("error=" + error);
          thisIns[destination] = records;
        });
    },
    gotoPreviousPage() {
      console.log("gotoPreviousPage called");
      this.$router.go(-1);
    },
    closeMenuDialog() {
      console.log("closeMenuDialog called");
      this.dialog = false;
    },
    getActiveStatusColor(status) {
      if (
        status == "Not completed" ||
        status == "Pending" ||
        status == "Process" ||
        status == "Returned" ||
        status == "Disabled" ||
        status == "Yet to complete" ||
        status == "Not eligible" ||
        status == "Suspended" ||
        status == "Waiting For Approval" ||
        status == "Waiting For Confirmation" ||
        status == "ZP Approval Pending" ||
        status == "NHQ Approval Pending"
      )
        return "warning";
      if (
        status == "Active" ||
        status == "Approved" ||
        status == "Used" ||
        status == "Enabled"
      )
        return "success";
      if (
        status == "Not Accepted" ||
        status == "Not scored" ||
        status == "Dissaffiliated" ||
        status == "Inactive" ||
        status == "Cancelled"
      )
        return "#ff0000";
      if (
        status == "Completed" ||
        status == "Closed" ||
        status == "Scored" ||
        status == "Provisional"
      )
        return "primary";
      return "dark";
    },
  },
  computed: {},
};
</script>
  